import ms from 'ms'
import {Optional} from 'data/types'

export default class Cache {
  private _cache: any = {}

  public set = <T>(key: string, value: T, duration?: string) => {
    this._cache[key] = value
    if (duration) {
      setTimeout(() => {
        this.remove(key)
      }, ms(duration))
    }
  }

  public get = <T>(key: string) => {
    return this._cache[key] as Optional<T>
  }

  public remove = (key: string) => {
    if (this._cache[key] != null) {
      delete this._cache[key]
    }
  }
}
